import axios from '../axios'

var HeatmapProvider = function () {
  return {
    async GetHeatmap (railobjectId, linear, dateFrom, dateTo, progressCallback) {
      const cb = (typeof progressCallback === 'function') ? progressCallback : null
      let lastPct = -1

      return axios.get('/switch/measurements/' + railobjectId + '/heatmap', {
        params: {
          lin: linear,
          dateFrom: dateFrom,
          dateTo: dateTo
        },
        responseType: 'blob',
        onDownloadProgress: (progressEvent) => {
          const total = typeof progressEvent.total === 'number' ? progressEvent.total : 0
          const loaded = typeof progressEvent.loaded === 'number' ? progressEvent.loaded : 0

          // When Content-Length is missing, total can be 0 so percentage is indeterminate.
          // Still emit 0 at start and increasing values when possible.
          const pct = total > 0 ? Math.round((loaded * 100) / total) : (loaded > 0 ? 0 : 0)
          if (cb && pct !== lastPct) {
            lastPct = pct
            try {
              cb(pct)
            } catch (e) { /* swallow callback errors */ }
          }
        }
      }).then((resp) => {
        // Ensure final 100% emit on success
        if (cb) {
          try {
            cb(Number(100))
          } catch (e) {}
        }
        return resp
      }).catch((err) => {
        // Optionally emit a terminal state on error
        if (cb) {
          try {
            cb(Number(0))
          } catch (e) {}
        }
        throw err
      })
    }
  }
}
export default new HeatmapProvider()



// WEBPACK FOOTER //
// ./src/providers/HeatmapProvider.js